  import { Component, OnInit, ViewEncapsulation } from '@angular/core';
  import { Title, Meta } from '@angular/platform-browser';
  import { CommonModule } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import { LoaderService } from '../../shared/loader/loader.service';
  import { ContactService, ContactForm } from './contact.service';
  import { CanonicalService } from '../../shared/seo/canonical.service';
import Swal from 'sweetalert2';

  @Component({
    selector: 'app-contact',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    encapsulation: ViewEncapsulation.None, // ✅ Make sure this line is here
  })
  export class ContactComponent implements OnInit {
  contactData: ContactForm = {
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: '',
  };

    isSubmitting = false;
    successMessage = '';
    errorMessage = '';

    captchaQuestion = '';
    captchaAnswer = 0;
    captchaInput = '';

  contactCards = [
    { 
      icon: 'bi-envelope', 
      title: 'Email Us', 
      text: 'support@maltech.co', 
      link: 'https://mail.google.com/mail/?view=cm&fs=1&to=support@maltech.co', 
      newTab: false,
      external: true
    },
        {
      icon: 'bi-chat-dots',
      title: 'Support Chat',
      text: 'Available 24/7 on our website',
      link: '/contact',
      newTab: false,
      external: false
    },
    { 
      icon: 'bi-telephone', 
      title: 'Call Us', 
      text: '+91 7305809591', 
      link: 'tel:+917305809591', 
      newTab: false,
      external: true
    },


    {
      icon: 'bi-whatsapp',
      title: 'WhatsApp',
      text: 'Connect with us directly on WhatsApp',
      link: 'https://wa.me/917305809591',
      newTab: true,
      external: true
    },
      { 
      icon: 'bi-telephone', 
      title: 'Call Us (Alternate)', 
      text: '+91 6369765570', 
      link: 'tel:+916369765570', 
      newTab: false,
      external: true
    },
    {
      icon: 'bi-whatsapp',
      title: 'WhatsApp (Alternate)', 
      text: 'Connect with us directly on WhatsApp',
      link: 'https://wa.me/916369765570',
      newTab: true,
      external: true
    },
    {
    icon: 'bi-geo-alt',
    title: 'Office Address <br/> (Hyderabad)',
    text: 'Plot No. 21, Second Floor, Devabhoomi Nagar, Third Right, Gajularamaram Road, near Chittaramma Temple, Hyderabad, Telangana 500055',
    link: 'https://www.maltech.co/contact/',   // Add Google Maps link when ready
    newTab: false,
    external: false
  },
  {
    icon: 'bi-geo-alt',
    title: 'Office Address <br> (Bapatla)',
    text: 'MALtech Solutions Private Limited, Ward No. 10, 5-1-32/34, Opposite to Vidhya Nagar, Viswabrahmana Colony, Bapatla, Andhra Pradesh 522101 India',
    link: 'https://www.google.com/maps?q=MALtech+Solutions+Private+Limited+Bapatla',
    newTab: true,
    external: true
  },

  ];

    constructor(
      private titleService: Title,
      private metaService: Meta,
      private loaderService: LoaderService,
      private contactService: ContactService,
      private canonicalService: CanonicalService
    ) {}

    ngOnInit(): void {
      this.titleService.setTitle('Contact MALtech | IT & Software Solutions');
      this.metaService.updateTag({
        name: 'description',
        content:
          'Contact MALtech - we respond within 2 working days. Reach out via this form or through our social channels for faster support.',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content: 'contact, MALtech, support, IT services, information',
      });
      this.metaService.updateTag({ name: 'robots', content: 'index, follow' });

      this.canonicalService.setCanonicalURL('contact/');

      // Generate Captcha on init
      this.generateCaptcha();
    }

    // Scroll to form
    contact() {
      const plansSection = document.getElementById('form');
      if (plansSection) {
        plansSection.scrollIntoView({ behavior: 'smooth' });
      }
    }

    // Generate random captcha
    generateCaptcha() {
      const num1 = Math.floor(Math.random() * 10);
      const num2 = Math.floor(Math.random() * 10);
      this.captchaAnswer = num1 + num2;
      this.captchaQuestion = `${num1} + ${num2} = ?`;
    }

  onSubmit(form: any): void {

  if (form.invalid) {
    Swal.fire({
      icon: 'warning',
      title: 'Please check your details',
      text: 'Please fix the highlighted errors before submitting.',
      confirmButtonText: 'OK'
    });
    return;
  }

  // Trim values first
  this.contactData.name = this.contactData.name.trim();
  this.contactData.email = this.contactData.email.trim();
  this.contactData.mobile = this.contactData.mobile.trim();
  this.contactData.message = this.contactData.message.trim();

  // Check for empty/space-only values
  if (
    !this.contactData.name ||
    !this.contactData.email ||
    !this.contactData.mobile ||
    !this.contactData.message
  ) {
    Swal.fire({
      icon: 'warning',
      title: 'Invalid Details',
      text: 'Fields cannot contain only spaces.',
      confirmButtonText: 'OK'
    });
    return;
  }

  // Captcha validation
  if (parseInt(this.captchaInput, 10) !== this.captchaAnswer) {

    Swal.fire({
      icon: 'error',
      title: 'Incorrect Captcha',
      text: 'Please enter the correct captcha answer.',
      confirmButtonText: 'Try Again'
    });

    this.generateCaptcha();
    this.captchaInput = '';

    return;
  }

  // Generate enquiry number
  const enquiryNumber =
    Math.floor(1000 + Math.random() * 9000);

  // Generate subject automatically
  this.contactData.subject =
    `${this.contactData.name} | New Contact Enquiry #${enquiryNumber}`;

  this.isSubmitting = true;

  this.contactService
    .sendContactEmail(this.contactData)
    .subscribe({

      next: (res) => {

        this.isSubmitting = false;

        form.resetForm();

        this.generateCaptcha();

        Swal.fire({
          icon: 'success',
          title: 'Message Sent Successfully!',
          text: 'Thank you for contacting MALtech. Our team will get back to you soon.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#009fe4'
        }).then(() => {

          // Optional: reload page after user clicks OK
          window.location.reload();

        });

      },

      error: (error) => {

        console.error(
          'Contact form submission failed:',
          error
        );

        this.isSubmitting = false;

        Swal.fire({
          icon: 'error',
          title: 'Something Went Wrong',
          text:
            error?.error?.message ||
            'We could not send your message. Please try again later.',
          confirmButtonText: 'OK'
        });

      }

    });
}


  
  }
